import { render } from "./EditAutor.vue?vue&type=template&id=504b5420&scoped=true"
import script from "./EditAutor.vue?vue&type=script&lang=js"
export * from "./EditAutor.vue?vue&type=script&lang=js"

import "./EditAutor.vue?vue&type=style&index=0&id=504b5420&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504b5420"]])

export default __exports__